import styles from "./Documents.module.scss";
import { useState } from "react";
import useParkingInfoStore from "../../stores/useParkingInfoStore";
import ParkingSessionDocument from "./ParkingSessionDocument";
import LoadButton from "../../components/LoadButton/LoadButton";
import { useTranslation } from "react-i18next";

export const LOAD_COUNT = 12;

const Documents: React.FC = () => {
	const { t } = useTranslation();
	const { sessions: parkingSessions } = useParkingInfoStore()
	const [sessionsShownCount, setSessionsShownCount] = useState(LOAD_COUNT);

	const shownSessions = parkingSessions.slice(0, sessionsShownCount);
	const remainingSessions = parkingSessions.length - shownSessions.length;
	const hasMoreItems = sessionsShownCount < parkingSessions.length;
	const nextLoadCount = Math.min(LOAD_COUNT, remainingSessions)

	const handleLoadMore = () => setSessionsShownCount(currentCount => currentCount + nextLoadCount)

	return (
		<div className={styles.container}>
			<div className={styles.wrapper}>
				<h1>{t("documents.title")}</h1>
				{shownSessions.length > 0 ? shownSessions.map((session) => {
					return (
						<ParkingSessionDocument
							key={session.ticket.ticketGUID}
							session={session}
						/>
					)
				}) : <p>{t("documents.noDocuments")}</p>
				}
			</div>
			{ hasMoreItems && 
				<LoadButton
					onClick={handleLoadMore}
					loadCount={nextLoadCount}
				/>
			}
		</div>
	)

};

export default Documents;
